import { render, staticRenderFns } from "./Kits.vue?vue&type=template&id=be04012c&"
import script from "./Kits.vue?vue&type=script&lang=js&"
export * from "./Kits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports